'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$() {
}
export { $c_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ as $c_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ };
$p = $c_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$;
/** @constructor */
function $h_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$() {
}
export { $h_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ as $h_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ };
$h_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$.prototype = $p;
$p.eu = (function() {
  return "";
});
var $d_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$, "samples.package$package$ExtraString$given_Defaultable_ExtraString$", ({
  rl: 1,
  aR: 1
}));
export { $d_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ as $d_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ };
var $n_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$;
function $m_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$() {
  if ((!$n_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$)) {
    $n_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ = new $c_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$();
  }
  return $n_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$;
}
export { $m_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ as $m_Lsamples_package$package$ExtraString$given\uff3fDefaultable\uff3fExtraString$ };
